import { mutationTypes, actionTypes } from './GlobalTypes'

function initialState() {
  return {
    snackbarObj: null,
    presentationMode: false,
  }
}

const mutations = {
  [mutationTypes.SET_SNACKBAR](state, snackbar) {
    state.snackbarObj = snackbar
  },
  [mutationTypes.SET_PRESENTATION_MODE](state, mode) {
    state.presentationMode = mode
  },
}

const actions = {
  [actionTypes.SHOW_SNACKBAR]({ commit }, { message, color }) {
    commit(mutationTypes.SET_SNACKBAR, { message, color: color || 'success' })
  },

  [actionTypes.ENABLE_PRESENTATION_MODE]({ commit }) {
    commit(mutationTypes.SET_PRESENTATION_MODE, true)
  },

  [actionTypes.DISABLE_PRESENTATION_MODE]({ commit }) {
    commit(mutationTypes.SET_PRESENTATION_MODE, false)
  },
}

export default {
  state: initialState,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Global.js